var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2258_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9919 32.5175L32.2422 17.3682C32.2148 17.217 32.121 17.086 31.9867 17.0113L25.0658 13.162C24.976 13.112 24.8753 13.0921 24.7764 13.0997L26.0355 29.3425L25.9933 29.3614L34.276 33.0772C34.3434 33.1073 34.4151 33.1222 34.4864 33.1222C34.5992 33.1222 34.7111 33.0851 34.803 33.0131C34.9533 32.8958 35.0259 32.705 34.9919 32.5175Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 16.8421L10.4218 13.1554C10.337 13.1112 10.2429 13.0931 10.1503 13.0993C10.1748 13.0978 10.1995 13.098 10.224 13.0999L8.96484 29.3426L17.2897 33.0774C17.3569 33.1075 17.4286 33.1224 17.5001 33.1224V16.8421Z",
    fill: "#44C868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2238 13.0997C10.1249 13.0921 10.0242 13.112 9.9344 13.1619L3.01348 17.0113C2.87909 17.086 2.7853 17.2169 2.75789 17.3682L0.00826313 32.5174C-0.0257799 32.7048 0.0469546 32.8957 0.19714 33.0131C0.289221 33.0851 0.400988 33.1222 0.513782 33.1222C0.585081 33.1222 0.65679 33.1074 0.724124 33.0772L8.96172 29.3816L10.2238 13.0997Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7761 13.0996C24.708 13.1049 24.6407 13.123 24.5783 13.1555L17.5 16.8422V33.1225C17.5 33.1225 17.5 33.1225 17.5001 33.1225C17.5715 33.1225 17.6433 33.1076 17.7104 33.0775L26.0353 29.3427L24.7761 13.0996Z",
    fill: "#4CE166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92453 21.9595L1.36597 25.037L9.63706 20.6684L9.82909 18.1911L9.86094 17.7803L1.92453 21.9595Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71155 19.7075L9.63711 20.6681L1.36602 25.0367L0.00826313 32.5175C-0.0257799 32.7049 0.0469546 32.8958 0.19714 33.0132C0.289221 33.0852 0.400988 33.1223 0.513782 33.1223C0.585081 33.1223 0.65679 33.1075 0.724124 33.0773L8.96172 29.3817L9.71155 19.7075Z",
    fill: "#A8EEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5022 18.8729L9.86108 17.7803L9.63721 20.6684L17.5001 32.6094V28.2673L12.8081 20.8791L17.5022 21.4406V18.8729Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4418 16.7086L28.1171 14.8594L24.9697 15.5948L25.0091 16.1031L25.1645 18.1084L31.4418 16.7086Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4437 21.7093L25.1456 17.8642L24.9697 15.5947L17.5022 18.8727V21.4404L22.3801 19.3192L25.4437 21.7093Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9919 32.5177L34.3013 28.7124L25.1646 18.1084L25.4437 21.7094L34.8138 33.0039C34.9562 32.8858 35.0251 32.7004 34.9919 32.5177Z",
    fill: "#FFBB24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5329 1.87744C13.5706 1.87744 10.3469 5.0984 10.3469 9.05751C10.3469 11.5066 11.5097 14.1359 13.8029 16.8725C15.4872 18.8825 17.1486 20.1752 17.2186 20.2293C17.3111 20.3009 17.422 20.3366 17.5329 20.3366C17.6438 20.3366 17.7548 20.3009 17.8473 20.2293C17.9172 20.1752 19.5787 18.8825 21.263 16.8725C23.5562 14.1359 24.719 11.5066 24.719 9.05751C24.7188 5.0984 21.4952 1.87744 17.5329 1.87744ZM20.1941 9.05745C20.1941 10.5259 19.0026 11.7165 17.5329 11.7165C16.0631 11.7165 14.8716 10.526 14.8716 9.05745C14.8716 7.58888 16.0631 6.3984 17.5329 6.3984C19.0026 6.3984 20.1941 7.58895 20.1941 9.05745Z",
    fill: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5328 1.87744C17.2188 1.87744 16.9095 1.89781 16.606 1.93705C20.1321 2.3928 22.8651 5.41217 22.8651 9.05751C22.8651 11.5066 21.7024 14.1359 19.4091 16.8725C18.326 18.1651 17.253 19.1603 16.606 19.721C16.9652 20.0322 17.1936 20.21 17.2185 20.2293C17.3111 20.3009 17.422 20.3366 17.5329 20.3366C17.6438 20.3366 17.7547 20.3009 17.8473 20.2293C17.9172 20.1752 19.5786 18.8825 21.2629 16.8725C23.5562 14.1359 24.7189 11.5066 24.7189 9.05751C24.7188 5.0984 21.4952 1.87744 17.5328 1.87744Z",
    fill: "#E7343F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7104 33.0773L20.8061 31.6886L17.5 28.2671V33.1224C17.5 33.1224 17.5 33.1224 17.5001 33.1224C17.5715 33.1224 17.6432 33.1076 17.7104 33.0773Z",
    fill: "#FFDB56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.242 17.3684C32.2146 17.2172 32.1208 17.0863 31.9864 17.0115L31.4416 16.7085L25.1643 18.1083L34.301 28.7123L32.242 17.3684Z",
    fill: "#1EA4E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 33.1227C17.5 33.1227 17.5 33.1227 17.4999 33.1227V32.6094L9.63705 20.6685L8.9646 29.3429L17.2895 33.0777C17.3567 33.1078 17.4284 33.1227 17.4999 33.1227Z",
    fill: "#1EA4E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2258_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.47bdbb9426915107b8b658a473c7b0a7.svg";
export { ForwardRef as ReactComponent };